import { useMemo } from 'react'
import { graphql, useStaticQuery } from 'gatsby'

interface QueryResult {
  formDataArr: {
    edges: {
      node: {
        content: string;
      }
    }[]
  }
}

export interface ContactForm {
  id: string;
  title: string;
  portalId: string;
  formId: string;
}

export function useGetAllContactForms(): ContactForm[] {
  const { formDataArr } = useStaticQuery<QueryResult>(graphql`
    query {
      formDataArr: allStoryblokEntry(
        filter: { field_component: { eq: "contactForm" } }
      ) {
        edges {
          node {
            name
            slug
            content
          }
        }
      }
    }
  `)

  return useMemo(() => {
    return formDataArr.edges
      .map((v) => {
        return JSON.parse(v.node.content)
      })
  }, [formDataArr])
}

export function useContactFormData({ id }: { id: string }) {
  const forms = useGetAllContactForms()

  return forms.find((v) => v.id === id)
}
